import { Alert } from 'antd'
import { Entities } from './Entities'

export const AlertBar : React.FC<{listLength: number, 
    limit : number, entity : Entities
}> = (props) => {

    const {listLength, limit, entity} = props

    const isLimitReached = () : boolean => {
        return listLength >= limit*2
    }
    
    const isLimitClose = () : boolean => {
        return (listLength < limit*2 && listLength >= limit*2-2)
    }

    return (
        <>
        {isLimitReached() && <Alert className="mb-3" message={`Osiągnięto maksymalny limit ${entity === Entities.MEAL ? `posiłków` : `rodziców`} aktywnych i nieaktywnych na liscie. Musisz poczekać do końca miesiąca,
            aż znikną z listy ${entity === Entities.MEAL ? `posiłki nieaktywne` : `rodzice nieaktywni`} lub poprosić administratora o wsparcie`} type="error" />}
        {isLimitClose() && <Alert className="mb-3" message={`Zbliżasz się do maksymalnego limitu ${entity === Entities.MEAL ? `posiłków` : `rodziców`} aktywnych i nieaktywnych na liście w danym miesiącu. 
            Osiągnięcie limitu spowoduje zablokowanie w tym miesiącu możliwości usuwania i dodawania nowych.`} type="warning" />}
        </>
    )
}